import { ReactComponent as Cross } from "../../assets/images/svg/Cross.svg";
import { ReactComponent as Recall } from "../../assets/images/svg/ReCall.svg";
import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";

function Feedback03(props) {
  const [feedbacks, setFeedbacks] = useState([]);

  console.log("<<<<<<<<<<", props.FBdata, ">>>>>>>>>>>>");

  useEffect(() => {
    setFeedbacks(props.feedback);
  }, [props.feedback]);

  const updateFBAnswer = (e, label) => {
    if (e.target.checked) {
      props.setFBdata((prevState) => ({
        ...prevState,
        fbanswer: { ...prevState.fbanswer, [label]: e.target.value },
      }));
    }
  };

  const updateComment = (value) => {
    props.setFBdata((prevState) => {
      return { ...prevState, comment: value };
    });
  };

  const updateFollowUp = (value) => {
    props.setFBdata((prevState) => {
      return { ...prevState, folloup: value };
    });
  };

  const updateDNC = (value) => {
    props.setFBdata((prevState) => {
      return { ...prevState, dnc: value };
    });
  };
  const updateCloseFeedback = (value) => {
    props.setFBdata((prevState) => {
      return { ...prevState, fdbk_close: value };
    });
  };

  return (
    <>
      {feedbacks.map((feedback, index) => (
        <div key={feedback.label}>
          <label className="mb-1.5 block text-sm font-medium text-gray-700">
            {feedback.label}
          </label>
          <div className="max-h-[250px] space-y-1 overflow-y-auto rounded-lg border border-gray-300 p-3">
            {feedback.option.map(function (item) {
              const isSelected = props.FBdata?.fbanswer[feedback.label] == item;
              return (
                <label
                  key={item}
                  className={`flex cursor-pointer items-center gap-3 rounded-md px-2 py-2 transition-colors ${
                    isSelected ? "bg-blue-50" : "hover:bg-gray-50"
                  }`}
                >
                  <input
                    className="h-4 w-4 shrink-0 cursor-pointer appearance-none rounded-full border border-gray-300 bg-white transition duration-200 checked:border-blue-600 checked:bg-blue-600 focus:outline-none"
                    type="radio"
                    name={index + "_icon"}
                    checked={isSelected}
                    value={item}
                    disabled={props?.viewfb || false}
                    onChange={(event) => {
                      updateFBAnswer(event, feedback.label);
                    }}
                  />
                  <span className="text-sm text-gray-800">{item}</span>
                </label>
              );
            })}
          </div>
        </div>
      ))}

      <div key={props.FBdata?.uid}>
        <label className="mb-1.5 block text-sm font-medium text-gray-700">
          Comment
        </label>
        <textarea
          id="Answer"
          rows={3}
          value={props.FBdata?.comment || ""}
          className="w-full rounded-lg border border-gray-300 bg-gray-50 px-3 py-2.5 text-sm text-gray-900 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:cursor-not-allowed disabled:opacity-60"
          onChange={(e) => {
            updateComment(e.target.value);
          }}
          disabled={props?.viewfb || false}
          required
        />
      </div>

      <div>
        <label className="mb-1.5 block text-sm font-medium text-gray-700">
          Follow up Date
        </label>
        <input
          type="datetime-local"
          className="w-full rounded-lg border border-gray-300 bg-gray-50 px-3 py-2.5 text-sm text-gray-700 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:cursor-not-allowed disabled:opacity-60"
          value={props?.FBdata?.folloup}
          onChange={(e) => updateFollowUp(e.target.value)}
          disabled={props?.viewfb || false}
        />
      </div>
      <div className="mt-6 flex items-center justify-between gap-3">
        <label className="flex w-fit items-center gap-3 cursor-pointer">
          <span className="text-base text-gray-400">
            DNC
          </span>
          <input
            type="checkbox"
            className="h-4 w-4 cursor-pointer rounded border-gray-300"
            checked={props?.FBdata?.dnc}
            onChange={(e) => updateDNC(e.target.checked)}
          />

        </label>
        <label className="flex items-center gap-2 text-sm text-gray-700">
          <span className="text-base text-gray-400 font-weight-bolder">
            Close feedback (remove from follow-up report)
          </span>
          <input
            type="checkbox"
            className="h-4 w-4 cursor-pointer rounded border-gray-300"
            // checked={!!FBdata.closed}
            // disabled={!editfbpermission}
            onChange={(e) =>
              updateCloseFeedback(e.target.checked)
            }
          />
        </label>
      </div>
      <div className="flex justify-between border-t border-gray-100 pt-5">
        <button
          onClick={() => {
            props.setcurrfback(props.back);
          }}
          className="rounded-full border border-gray-300 bg-white px-6 py-2.5 text-sm font-semibold text-gray-700 transition-colors hover:bg-gray-50 active:scale-95"
        >
          Back
        </button>
        {props?.editfbpermission && (
          <button
            onClick={() => {
              props.submitData();
            }}
            className="rounded-full px-6 py-2.5 text-sm font-semibold text-white shadow-sm transition-transform active:scale-95"
            style={{
              backgroundImage:
                "linear-gradient(177.88deg, #AFD462 1.79%, #6BC698 49.97%, #0FB1E2 82.06%)",
            }}
          >
            Complete
          </button>
        )}
      </div>
    </>
  );
}
export default Feedback03;
